import { translate as $t } from '@/assets/languages'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    keepAlive: [], // 动态缓存的页面name数组
    fromName: '', // 前一个页面的名字
    provider: null,
    ad2earn: null,
    isPc: null,
    wallet: null,
    usdt: null,
    loginType: null,
    isWebview: false,
    userid: localStorage.getItem('user_id')
      ? localStorage.getItem('user_id')
      : null,
    refresh: {}, // 需要强制刷新的页面name对象
    homeConfig: localStorage.getItem('home_config')
      ? JSON.parse(localStorage.getItem('home_config'))
      : null, // 配置
    lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en',
    remTopx: (document.body.clientWidth / 100) * 26.6666
  },
  mutations: {
    SET_ISPC: (state, data) => {
      state.isPc = data
    },
    SET_KEEP_ALIVE: (state, keepAlive) => {
      state.keepAlive = keepAlive
    },
    SET_FROM_NAME: (state, name) => {
      state.fromName = name
    },
    SET_WALLET: (state, data) => {
      state.wallet = data
    },
    SET_PROVIDER: (state, data) => {
      state.provider = data
    },
    SET_AD2EARN: (state, data) => {
      state.ad2earn = data
    },
    LOG_OUT: (state) => {
      state.provider = null
      state.wallet = null
    },
    SET_REFRESH: (state, data) => {
      if (data.type) {
        state.refresh[data.name] = true
      } else {
        delete state.refresh[data.name]
      }
    },
    SET_HOME_CONFIG: (state, data) => {
      state.homeConfig = data
    },
    SET_LANG: (state, data) => {
      state.lang = data
    },
    SET_USDT: (state, data) => {
      state.usdt = data
    },
    SET_TYPE: (state, data) => {
      state.loginType = data
    },
    SET_WEBVIEW: (state, data) => {
      state.isWebview = data
    }
  },
  actions: {
    Login({ commit }, data) {
      commit('SET_WALLET', data)
    },
    LogOut({ commit }) {
      localStorage.clear()
      commit('SET_KEEP_ALIVE', [])
      commit('SET_WALLET', null)
      commit('LOG_OUT')
    },
    setRefresh({ commit }, data) {
      commit('SET_REFRESH', data)
    },
    setLang({ commit }, data) {
      localStorage.setItem('lang', data)
      commit('SET_LANG', data)
    }
  },
  getters: {
    keepAlive: (state) => state.keepAlive
  },
  modules: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js